module.exports = __webpack_public_path__ + "media/images/lb/432-ee4dc27cc4744352db22a145a4b8bca7.svg";